(function () {

  const toggleOpen = document.getElementById("toggleOpen");
  const toggleClose = document.getElementById("toggleClose");
  const collapseMenu = document.getElementById("collapseMenu");
  const body = document.querySelector("body");
  const header = document.querySelector("header");
  const blocker = document.querySelector(".blocker");

  function handleClick() {
    if (collapseMenu.style.display === "block") {
      collapseMenu.style.display = "none";
      body.classList.remove("overflow-hidden");
    } else {
      collapseMenu.style.maxHeight = "100vh";
      collapseMenu.style.display = "block";
      body.classList.add("overflow-hidden");
    }
  }

  function handleClickClose() {
    if (window.innerWidth >= 1024) {
      document.querySelectorAll('.clickable > a').forEach(otherItem => {
        otherItem.classList.remove('active');
        const otherSubmenu = otherItem.nextElementSibling;
        if (otherSubmenu) {
          otherSubmenu.style.maxHeight = null;
          otherSubmenu.classList.remove('open');
          const otherArrow = otherItem.querySelector('svg');
          if (otherArrow) {
            otherArrow.classList.remove('-rotate-90');
          }
        }
      });
      blocker.classList.remove('enabled');
      header.classList.remove("lg:bg-white");
    }
  }

  toggleOpen.addEventListener("click", handleClick);
  toggleClose.addEventListener("click", handleClick);
  blocker.addEventListener("click", handleClickClose);

  document.querySelectorAll('.clickable > a').forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      const submenu = this.nextElementSibling;
      const arrow = this.querySelector('svg');
      if (window.innerWidth >= 1024) {
        document.querySelectorAll('.clickable > a').forEach(otherItem => {
          if (otherItem !== this && otherItem.classList.contains('active')) {
            otherItem.classList.remove('active');
            const otherSubmenu = otherItem.nextElementSibling;
            if (otherSubmenu) {
              otherSubmenu.style.maxHeight = null;
              otherSubmenu.classList.remove('open');
              const otherArrow = otherItem.querySelector('svg');
              if (otherArrow) {
                otherArrow.classList.remove('-rotate-90');
              }
            }
          }
        });
      }

      this.classList.toggle('active');

      if (submenu.classList.contains('open')) {
        if (window.innerWidth < 1024) {
          submenu.style.maxHeight = null;
        }

        if (window.innerWidth >= 1024) {
          blocker.classList.remove('enabled');
        }
        submenu.classList.remove('open');
        header.classList.remove("lg:bg-white");
      } else {
        if (window.innerWidth < 1024) {
          submenu.style.maxHeight = submenu.scrollHeight + "px";
        }
        if (window.innerWidth >= 1024) {
          blocker.classList.add('enabled');
        }
        submenu.classList.add('open');
        header.classList.add("lg:bg-white");
      }

      if (arrow) {
        arrow.classList.toggle('-rotate-90');
      }
    });
  });

  document.getElementById('language-toggle').addEventListener('click', function (event) {
    const dropdown = document.getElementById('language-dropdown');
    document.getElementById('language-toggle').classList.toggle('bg-white');
    dropdown.classList.toggle('hidden');
  });

  document.addEventListener('DOMContentLoaded', () => {

    const selectedLang = document.getElementById('language-toggle').getAttribute('data-lang-initial') ?? 'en';

    const dropdownItems = document.querySelectorAll('#language-dropdown li');

    dropdownItems.forEach(item => {
      if (item.dataset.lang === selectedLang) {
        item.style.display = 'none';
      }
    });
  });

})();